/* Nilo V5.13.60 — display compare-at price for the selected Shopify variant on product CTA only. */
(function(){'use strict';
  var page=document.querySelector('[data-nilo-product-page]');
  if(!page)return;
  var form=page.querySelector('#NiloProductForm');
  if(!form)return;
  var select=form.querySelector('[data-nilo-variant-select]');
  var compare=form.querySelector('[data-nilo-button-compare]');
  var sale=form.querySelector('[data-nilo-button-price]');
  if(!compare||!sale)return;
  function synchronize(){
    if(!select)return; // One-variant product: the Liquid-rendered prices are authoritative.
    var opt=select.selectedOptions&&select.selectedOptions[0];
    if(!opt||!opt.value)return; // No complete variant: preserve Liquid's starting price.
    var current=String(opt.getAttribute('data-price')||'').trim();
    var previous=String(opt.getAttribute('data-compare')||'').trim();
    if(current)sale.textContent=current;
    compare.textContent=previous;
    compare.hidden=!previous;
  }
  if(select)select.addEventListener('change',synchronize);
  // The theme's pill selector updates the hidden variant select during clicks.
  page.addEventListener('click',function(e){
    if(e.target.closest('[data-nilo-option-value]'))window.requestAnimationFrame(synchronize);
  });
  synchronize();
})();
